import * as zod from 'zod';

export const AgentFeedbackData = zod.object({
  id: zod.string(),
  sessionID: zod.string(),
  messageID: zod.string(),
  sentiment: zod.enum(['up', 'down']),
  content: zod.string().nullable(),
  routineSnapshot: zod.unknown().nullable(),
  conversationSnapshotMessageIDs: zod.array(zod.string()),
  createdAt: zod.string(),
});

export type AgentFeedbackData = zod.infer<typeof AgentFeedbackData>;

export const AgentFeedbackCreateInput = zod.object({
  sessionID: zod.string(),
  messageID: zod.string(),
  sentiment: zod.enum(['up', 'down']),
  content: zod.string().nullable().optional(),
  routineSnapshot: zod.unknown().nullable().optional(),
  conversationSnapshotMessageIDs: zod.array(zod.string()),
});

export type AgentFeedbackCreateInput = zod.infer<
  typeof AgentFeedbackCreateInput
>;
